export default {
  SET_SELECT_MEMBER(state,Member){
      state.selectMember = Member
  },
  SET_RESULT(state,result){
      state.Result = result
  },
  SET_EDIT_MEMBER(state,editMember){
      state.editMember = editMember
  },
}